export const getClientSignInRedirectUrl = (
  medspaSlug: string,
  resolvedUrl: string
) => {
  return `/client/${medspaSlug}/sign-in?redirectTo=${encodeURIComponent(resolvedUrl)}`;
};

export function isInternalPath(path: string): boolean {
  return path?.startsWith("/") && !path?.startsWith("//");
}
